import { call, takeLatest } from "redux-saga/effects";
import * as folderApi from "../apis/folderApi";
import { ADD_FOLDER, FOLDER_DELETE, FOLDER_EDIT, FOLDER_LIST, FOLDER_VIEW } from "../actions/types";

export function* addFolderWorker(action) {
    try {
        const res = yield call(folderApi.addFolderApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* folderListWorker(action) {
    try {
        const res = yield call(folderApi.folderListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* folderEditWorker(action) {
    try {
        const res = yield call(folderApi.folderEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* folderDeleteWorker(action) {
    try {
        const res = yield call(folderApi.folderDeleteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* folderViewWorker(action) {
    try {
        const res = yield call(folderApi.folderViewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* addFolderWatcher() {
    yield takeLatest(ADD_FOLDER, addFolderWorker);
}

export function* folderListWatcher() {
    yield takeLatest(FOLDER_LIST, folderListWorker);
}

export function* folderEditWatcher() {
    yield takeLatest(FOLDER_EDIT, folderEditWorker);
}

export function* folderDeleteWatcher() {
    yield takeLatest(FOLDER_DELETE, folderDeleteWorker);
}

export function* folderViewWatcher() {
    yield takeLatest(FOLDER_VIEW, folderViewWorker);
}